import React from 'react';
import { ChevronDown } from 'lucide-react';
import { ExchangeLogo } from '@/components/ui/ExchangeLogo';

export type ExchangeFilterOption = 'all' | 'bybit' | 'binance' | 'gate' | 'aster' | 'kucoin' | 'hyperliquid';

interface ExchangeFilterSelectProps {
  value: ExchangeFilterOption;
  onChange: (value: ExchangeFilterOption) => void;
  className?: string;
}

const exchangeOptions: { value: ExchangeFilterOption; label: string }[] = [
  { value: 'all', label: 'All Exchanges' },
  { value: 'binance', label: 'Binance' },
  { value: 'bybit', label: 'Bybit' },
  { value: 'gate', label: 'Gate.io' },
  { value: 'kucoin', label: 'KuCoin' },
  { value: 'aster', label: 'Aster' },
  { value: 'hyperliquid', label: 'Hyperliquid' },
];

/**
 * Exchange filter dropdown select for desktop.
 * Replaces the drawer-based filter on mobile.
 */
export const ExchangeFilterSelect: React.FC<ExchangeFilterSelectProps> = ({
  value,
  onChange,
  className = '',
}) => {
  return (
    <div className={`relative ${className}`}>
      <span className="pointer-events-none absolute left-1.5 top-1/2 z-10 flex size-8 -translate-y-1/2 items-center justify-center">
        {value === 'all' ? (
          <img src="/logo-mark.svg" alt="" width={24} height={20} />
        ) : (
          <ExchangeLogo code={value} size={22} />
        )}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as ExchangeFilterOption)}
        aria-label="Exchange"
        className="glass h-11 w-full cursor-pointer appearance-none !rounded-lg py-2 pl-11 pr-10 text-sm font-semibold text-[#fafafa] transition-colors hover:border-[#2dcc89]/50 focus:border-[#2dcc89] focus:outline-none"
      >
        {exchangeOptions.map((option) => (
          <option key={option.value} value={option.value} className="bg-[#0d121a]">
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#a3a3a3]" />
    </div>
  );
};
